import React from 'react';
import '../assets/styles/DashboardTemplateTabs.css';

/**
 * DashboardTemplateTabs - the underline tab strip (mockup "1a") shown as a
 * second white bar directly under the header on /my-dashboard. "My
 * Dashboard" is always the first tab and is not a backend row; the rest
 * come from GET /getDashboardTemplates.
 */
const CUSTOM_TAB = { slug: 'custom', name: 'My Dashboard' };

const DashboardTemplateTabs = ({ templates, activeView, onSelect }) => {
  const tabs = [CUSTOM_TAB, ...templates];

  return (
    <div className="dashboard-template-tabs">
      <nav className="dashboard-template-tabs-row">
        {tabs.map((tab) => (
          <div
            key={tab.slug}
            className={`dashboard-template-tab ${activeView === tab.slug ? 'active' : ''}`}
            onClick={() => onSelect(tab.slug)}
          >
            {tab.name}
          </div>
        ))}
      </nav>
    </div>
  );
};

export default DashboardTemplateTabs;
